import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { SupabaseService } from "../../../services/supabase.service";

export const authPageGuard: CanMatchFn = async (_, __) => {
  const router = inject(Router);
  const supabase = inject(SupabaseService);
  const isLoggedIn = await lastValueFrom(supabase.isLoggedIn);

  if (isLoggedIn) {
    return router.createUrlTree(["/dashboard"]);
  }

  return true;
};
